export default __webpack_public_path__ + "static/media/promise.3156754c.png";